<template>
    <div id="app">
        <div style="height:120px;width:100%;background-color: rgba(196,0,1);display: flex;justify-content: center;">
            <div style="width:1200px;height: 100%;display: flex;justify-content: flex-start;align-items: center;">
                <img src="../../static/other/logo2.png" width="321px" height="92px">
                <span style="font-size: 36px;font-weight: 500;color:#fff;margin-left:20px;display: none;">人事处</span>
            </div>
        </div>
        <div class="header" style="box-shadow:  0 1px 10px rgba(0, 0, 0, 0.2);height: 60px;">
            <div id="menu_index" style="display:flex;align-items: center;">
                <!-- web端菜单导航 -->
                <el-menu :default-active="activeIndex" active-text-color="#C40001" class="el-menu-demo"  text-color="#333" 
                style="display:flex;width:1200px;justify-content: space-around;align-items: center;
                height: 100%; border:0;" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1" class="header-title">招聘首页</el-menu-item>
                    <el-menu-item index="2" class="header-title">应聘须知</el-menu-item>
                    <el-submenu index="3" class="header-title">
                        <template  slot="title">招聘岗位</template>
                        <el-menu-item  class="sub-header-title" v-if="jobList1.length>0" v-for="item in jobList1" :index="item.id">{{item.jobTitle}}</el-menu-item>
                    </el-submenu>
                    <el-menu-item v-if="boshi.length>0" index="4" class="header-title">{{boshi[0].jobTitle}}</el-menu-item>
                    <el-menu-item v-if="rencai.length>0" index="5" class="header-title">{{rencai[0].jobTitle}}</el-menu-item>

                    <el-menu-item index="6" class="header-title">西安美术学院官网首页</el-menu-item>
                    <el-menu-item index="7" class="header-title">个人中心</el-menu-item>
                </el-menu>
            </div>
            <div  style="display: flex;align-items: center; height: 100%;width: 200px;justify-content: center;font-size:12px;">
                
                <el-button v-if="getSessionStorage('id')==null" type="primary" style="border-color: #c40001;padding:5px 15px;color:#fff;background-color: #c40001;border-radius: 5px;"  @click="login" round>登录</el-button>
                <el-button v-if="getSessionStorage('id')==null" type="primary"  style="border-color: #c40001;padding:5px 15px;color:#fff;background-color: #c40001;border-radius: 5px;" @click="register" round>注册</el-button>
                <el-button v-if="getSessionStorage('id') != null" type="primary"  style="border-color: #c40001;padding:5px 15px;color:#fff;background-color: #c40001;border-radius: 5px;" @click="loginOut" round>退出</el-button>

            </div>
        </div>
        <div class="container"  style="clear:both;">
            <router-view :selectJob="selectJob"></router-view>
        </div>

        <div class="footer_tip" style="display:none;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div>
        <div class="footer">
            <div style="width:1200px;height:100%;display: flex;justify-content: space-between;align-items: center;">
                <div style="flex-direction: column;display: flex;justify-content: center;align-items: flex-start;width:55%;">
                    <div style="border-bottom: 1px solid #fff;width:100%;height: 50px;line-height: 50px;font-weight: bold;font-size: 16px;">联系我们</div>
                    <div style="line-height:30px;color:#eeeeee;margin-top:10px;font-size: 13px;">地址：陕西省西安市雁塔区含光南路100号 西安美术学院 / 邮编：710065 / 电话：029-88216989</div>
                    <div style="line-height:30px;color:#eeeeee;font-size: 13px;">版权声明 © 西安美术学院信息中心版权所有 / 陕ICP备 05010976号-1</div>
                </div>
                <div style="display: flex;justify-content: flex-end;align-items: center;width:45%;box-sizing: border-box;">
                    <img src="../../static/other/logo3.png" width="325px" height="81px">
                    <span style="font-size: 36px;font-weight: 500;color:#fff;margin-left:20px;display: none;">人事处</span>
                </div>
            </div>       
                
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "Layout",
        data() {
            return {       
                selectJob:'0',         
                activeIndex: '1',
                scroll: '',
                timer: '',
                minHeight:'100%',
                jobList:[],
                jobList1:[],
                boshi:[],
                rencai:[],
            };
        },
        methods: {
            handleSelect(key,keyPath) {
                switch (keyPath[0]){
                    case '1':
                        this.selectJob='0';
                        this.$router.push({name: "Index"});
                        break;
                    case '2':
                        this.$router.push({name: "ApplyKnow"});
                        break;
                    case '3':
                        // this.selectJob='1';
                        // this.$router.push({name: "Index"}); 
                        //window.location.hash = "#job";  

                        //定位到岗位招聘锚点
                        // if (document.getElementById('job') != undefined){
                        //     document.documentElement .scrollTop = document.getElementById('job').getBoundingClientRect().top;
                        // }
                        this.$router.push({name:'Job',query:{jobId:keyPath[1]}});
                        break;
                    case '4':
                        this.$router.push({name:'Job',query:{jobId:this.boshi[0].id}});
                        break;
                    case '5':
                        this.$router.push({name:'Job',query:{jobId:this.rencai[0].id}});
                        break;

                    case '6':
                        window.open('https://www.xafa.edu.cn/','_blank');                       
                        break;
                    case '7':
                        var id=this.getSessionStorage('id');
                        if (id == null){
                            this.$router.push({name: "Login"});  
                        }else{
                            this.$router.push({name: "JobEdit"});  
                        }          
                        break;

                }
            },
            handleScroll(){
                // this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
                // if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
                //     this.$refs.btn.style.display = 'block';
                // }else{
                //     this.$refs.btn.style.display = 'none'
                // }
            },
            backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                // this.timer = setInterval(() => {
                //     let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                //     let ispeed = Math.floor(-osTop / 5)
                //     document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                //     if (osTop === 0) {
                //         clearInterval(this.timer)
                //     }
                // }, 30)
            },
            login(){
                this.$router.push({name: "Login"});  
            },
            register(){
                this.$router.push({name: "Register"});  
            },
            loginOut(){
                this.removeSessionStorage('id');
                this.$router.push({name: "Index"});  
                window.location.reload();
            },

            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            },
            getDataList(){
                var that=this;
                console.log('globalUrl:'+this.Global.globalUrl);
                this.$axios.get(this.Global.globalUrl+'/interface/getLayout.ashx',
                    {
                        headers:{
                            'token':JSON.stringify(this.getToken())
                            }
                    }
                )
                .then((res) => {
                    if (res.data.err==0){
                        that.jobList = res.data.jobList; 
                        that.jobList1=that.jobList.filter(item=>item.type==1); 
                        that.boshi=that.jobList.filter(item=>item.type==2); 
                        that.rencai=that.jobList.filter(item=>item.type==3);   
                    }else{
                        this.$message({
                        duration:5000,                      
                        type: 'error',
                        message: res.data.errMsg
                    });

                    }            
                })
                .catch(() => {
                })

            },


        },
        mounted() {
            var h1 = document.documentElement.clientHeight;//可视区高度
            var h2 = document.body.clientHeight;//文档高度
            this.$nextTick(function () {
                this.getDataList();
            })

            //window.addEventListener('scroll', this.handleScroll)
           
        },
    }
</script>

<style scoped>
    /* .header{
        background-image: url(../../static/other/header_bg.jpg);
        width:100%;
        height:100%;
    } */
    .header_logo{
        
        width: 200px;
        cursor: pointer;
        display:flex;
        align-items: center;
        height:100px;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }       
    
    .header-title{
        font-size: 17px;
        font-weight: bold;
    }
    .sub-header-title{
        font-size: 13px;
        font-weight: bold;
    }
    .el-submenu /deep/ .el-submenu__title{
        font-size: 17px;
        font-weight: bold;
    }
    .company_name{
        font-weight: normal;
        font-size: 1em;
    }
    
    
    .header{
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        /*background: #F56C6C;*/
    }
    #header-img{
        width: 197px;
        height: 50px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 197px;
        align-self: center;
    }
    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .footer{
      width: 100%;
      height: 160px;  
      background-color:rgba(161,5,9);
      display: flex;
      justify-content: center;
      color:#fff;
    }
    .footer_tip{
        width: 90%;
        margin: 20px auto;
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
</style>